import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Collections from "./components/Collections";
import HotRank from "./components/HotRank";
import Topics from "./components/Topics";
import About from "./components/About";
import Faq from "./components/Faq";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function ScrollTopButton() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <a
      href="#top"
      aria-label="回到顶部"
      className={
        "fixed bottom-6 right-5 z-40 flex h-11 w-11 cursor-pointer items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg shadow-primary-500/30 transition-all hover:bg-primary-600 " +
        (show ? "opacity-100" : "pointer-events-none opacity-0")
      }
    >
      <i className="ri-arrow-up-line text-xl" />
    </a>
  );
}

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Collections />
        <HotRank />
        <Topics />
        <About />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <ScrollTopButton />
    </>
  );
}